<script setup>
import InputVue from './InputCompVue'

import { ref, useTemplateRef } from 'vue'

const DEFAULT_VAL = 1

const { modelValue } = defineProps({
  name: String,
  label: String,
  cssClasses: String,
  labelAsPlaceholder: Boolean,
  placeholder: String,
  modelValue: {
    type: Number,
    default: DEFAULT_VAL,
  },
  alignment: {
    type: String,
    default: 'horizontal',
  },
  step: {
    type: Number,
    default: 1,
  },
})
const emit = defineEmits([
  'update:modelValue',
])
const hasError = ref(false)
const inputEl = useTemplateRef('inputEl')
const val = ref(modelValue)
console.log('val', val.value)

const onInput = (e) => {
  val.value = e.target.value
  emit('update:modelValue', val.value)
}

const reset = () => {
  val.value = DEFAULT_VAL
}

const getValue = () => {
  return val.value
}

const focusInput = () => {
  inputEl.value.focus()
}

defineExpose({ reset, getValue })

</script>

<template>
  <InputVue
    :name="name"
    :label="label"
    :tabindex="0"
    class="number-input-cont"
    :cssClasses="cssClasses"
    :labelAsPlaceholder="labelAsPlaceholder"
    :hasError="hasError"
    :alignment="alignment"
    @input="onInput">
    <template #input-slot>
      <div class="number-input-wrapper">
        <input 
          ref="inputEl"
          class="form-control" 
          autocomplete="off"
          :value="modelValue"
          :name="name" 
          :step="step"
          type="number"
          @input="onInput"
          :placeholder="labelAsPlaceholder ? label : placeholder " />
      </div>
    </template>
  </InputVue>
</template>

<style lang="scss" scoped>
.number-input-vue-wrapper {
}
</style>
